import {Pipe, PipeTransform, inject} from '@angular/core';
import {FieldSeasonShortDto} from '@6grain/masofa-monolith-api-client/crop-monitoring';
import {ServerTranslateService} from '@services/server-translate.service';
import {
  buildFieldSeasonRowViews,
  FieldSeasonRowView,
} from '@app/pages/electronic-field-map/pages/fields/field-llst/field-list-season-display.util';

@Pipe({
  name: 'fieldListSeasonRows',
  standalone: true,
})
export class FieldListSeasonRowsPipe implements PipeTransform {
  private readonly serverTranslate = inject(ServerTranslateService);

  transform(
    seasons: FieldSeasonShortDto[] | null | undefined,
    _lang?: string | null,
  ): FieldSeasonRowView[] {
    if (!seasons?.length) return [];
    return buildFieldSeasonRowViews(seasons, this.serverTranslate);
  }
}
